module.exports = __webpack_public_path__ + "img/logo_navbar.3bdb7ba9.png";